import React from "react";

const NotFound = () => {
    return (
        <div className="container notFoundPage">
            <h1>404 </h1>
            <p>Tu es perdu petit robot ? </p>
            <img src="/img/404notfound.png" alt="petit robot perdu dans la foret"/>
        </div>
    );
}

export default NotFound;